import "styles/profile"
import VueApollo from "vue-apollo"
import gql from "graphql-tag"

import AppBarNav from "vuecomponents/app_bar_nav"
import FollowButton from "vuecomponents/follow_button"
import PadletCollection from "vuecomponents/padlet_collection"
import EmptyMessage from "vuecomponents/empty_message"
import BridgedA from "vuecomponents/bridged_a"
import currentUser from "bits/current_user"
import { apolloProvider } from "bits/apollo"

Vue.use(VueApollo)

document.addEventListener('DOMContentLoaded', function() {
  window.app = new Vue({
    components: { AppBarNav, FollowButton, PadletCollection, EmptyMessage, BridgedA },
    el: "#app",
    data: {
      madeWalls: [],
      contributedWalls: [],
      likedWalls: [],
      madeWallsLoading: 0,
      contributedWallsLoading: 0,
      likedWallsLoading: 0,
      currentUser: currentUser,
      profileUser: window.$profileUser
    },
    apollo: {
      madeWalls: {
        query: function() {
          return gql`
            query {
              user(id: ${this.profileUser.id}) {
                walls: made_walls {
                  id
                  title
                  public_tag_list
                  updated_at
                  address
                  background {
                    fill
                    url
                    dominant_color
                  }
                  builder {
                    avatar
                    username
                    display_name
                  }
                }
              }
            }
          `
        },
        fetchPolicy: "cache-and-network",
        loadingKey: "madeWallsLoading",
        update: data => data.user.walls || []
      },
      contributedWalls: {
        query: function() {
          return gql`
            query {
              user(id: ${this.profileUser.id}) {
                walls: contributed_walls {
                  id
                  title
                  public_tag_list
                  updated_at
                  address
                  background {
                    fill
                    url
                    dominant_color
                  }
                  builder {
                    avatar
                    username
                    display_name
                  }
                }
              }
            }
          `
        },
        fetchPolicy: "cache-and-network",
        loadingKey: "contributedWallsLoading",
        update: data => data.user.walls || []
      },
      likedWalls: {
        query: function() {
          return gql`
            query {
              user(id: ${this.profileUser.id}) {
                walls: liked_walls {
                  id
                  title
                  public_tag_list
                  updated_at
                  address
                  background {
                    fill
                    url
                    dominant_color
                  }
                  builder {
                    avatar
                    username
                    display_name
                  }
                }
              }
            }
          `
        },
        fetchPolicy: "cache-and-network",
        loadingKey: "likedWallsLoading",
        update: data => data.user.walls || []
      }
    },
    computed: {
      isEmpty: function() {
        return !this.isLoading && this.madeWalls.length == 0 && this.contributedWalls.length == 0 && this.likedWalls.length == 0
      },
      isLoading: function() {
        return this.madeWallsLoading > 0 || this.contributedWallsLoading > 0 || this.likedWallsLoading > 0
      }
    },
    apolloProvider
  });
});
